// src/pages/Events/EventEntry.js - COMPLETE FILE
import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { axiosInstance } from "../../utils/axios";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";

import {
  Box,
  Button,
  Checkbox,
  Divider as MuiDivider,
  Grid,
  Paper as MuiPaper,
  Typography,
  MenuItem,
  DialogActions,
  TextField,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Snackbar,
  Alert,
  CircularProgress,
  Chip,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";

const Divider = styled(MuiDivider)(spacing);

const Paper = styled(MuiPaper)(spacing);

// Entry type labels
const entryTypeLabels = {
  "anyone-link": "Anyone can enter via their unique link",
  "invited-only": "Only invited people can enter",
  "anyone-signin": "Anyone can enter after sign in",
  "anyone-no-signin": "Anyone can enter without sign in",
};

// List of countries for dropdown
const countries = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "VG", name: "British Virgin Islands" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Cape Verde" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo Republic" },
  { code: "CD", name: "Congo" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Cote D'Ivoire" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "XK", name: "Kosovo" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macau" },
  { code: "MK", name: "Macedonia" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "KP", name: "North Korea" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "Reunion" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" },
  { code: "BL", name: "Saint Barthelemy" },
  { code: "SH", name: "Saint Helena" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "KR", name: "South Korea" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SZ", name: "Swaziland" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "VI", name: "U.S. Virgin Islands" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VA", name: "Vatican" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

// Validation schema for the new attendee form
const attendeeValidationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  jobTitle: Yup.string().required("Job Title is required"),
  organization: Yup.string().required("Organization is required"),
  city: Yup.string().required("City is required"),
  country: Yup.string().required("Country is required"),
  addedVia: Yup.string().required("Please select an option"),
});

function EventEntryTab({ eventId }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attendeeLoading, setAttendeeLoading] = useState(false);
  const [entrySettings, setEntrySettings] = useState({
    entryType: "anyone-link",
  });
  // Temporary state for the drawer - only updates main state on save
  const [tempEntrySettings, setTempEntrySettings] = useState({
    entryType: "anyone-link",
  });
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  // Fetch event entry settings on component mount
  useEffect(() => {
    fetchEventSettings();
  }, [eventId]);

  const fetchEventSettings = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          query GetEvent($eventId: ID!) {
            getEvent(id: $eventId) {
              id
              name
              entrySettings {
                entryType
              }
            }
          }
        `,
        variables: {
          eventId,
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error fetching event settings"
        );
      }

      const event = response.data.getEvent;

      if (event?.entrySettings) {
        const settings = {
          entryType: event.entrySettings.entryType || "anyone-link",
        };
        setEntrySettings(settings);
        setTempEntrySettings(settings);
      }
    } catch (error) {
      console.error("Error fetching event settings:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to load event settings",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateEventEntrySettings = async (newEntryType) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation UpdateEventEntrySettings($eventId: ID!, $input: EventEntrySettingsInput!) {
            updateEventEntrySettings(eventId: $eventId, input: $input) {
              id
              entrySettings {
                entryType
              }
            }
          }
        `,
        variables: {
          eventId,
          input: {
            entryType: newEntryType,
          },
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error updating event settings"
        );
      }

      // Update local state with new settings
      setEntrySettings({
        entryType: newEntryType,
      });

      setAlert({
        open: true,
        message: "Event entry settings updated successfully",
        severity: "success",
      });

      // Close the drawer
      setState({ ...state, right: false });
    } catch (error) {
      console.error("Error updating event settings:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to update event settings",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAttendee = async (values, { resetForm }) => {
    try {
      setAttendeeLoading(true);

      // Set registration status based on addedVia value
      const registrationStatus =
        values.addedVia === "Register" ? "Registered" : "Pending";

      const response = await axiosInstance.post("/graphql", {
        query: `
        mutation CreateAttendee($input: CreateAttendeeInput!) {
          createAttendee(input: $input) {
            id
            firstName
            lastName
            email
            jobTitle
            organization
            city
            country
            addedVia
            registrationStatus
          }
        }
      `,
        variables: {
          input: {
            eventId,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            jobTitle: values.jobTitle,
            organization: values.organization,
            city: values.city,
            country: values.country,
            addedVia: values.addedVia,
            sendEmail: values.sendEmail,
            // Add registration status based on addedVia
            registrationStatus: registrationStatus,
          },
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error creating attendee"
        );
      }

      // Success
      setAlert({
        open: true,
        message: "Attendee added successfully!",
        severity: "success",
      });

      // Reset form and close dialog
      resetForm();
      setOpen(false);
    } catch (error) {
      console.error("Error creating attendee:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to create attendee",
        severity: "error",
      });
    } finally {
      setAttendeeLoading(false);
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    // When opening the drawer, reset temp settings to current settings
    if (open) {
      setTempEntrySettings({ ...entrySettings });
    }

    setState({ ...state, [anchor]: open });
  };

  const handleCancel = () => {
    // Reset temp settings to current settings when canceling
    setTempEntrySettings({ ...entrySettings });
    setState({ ...state, right: false });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      style={{ width: "400px" }}
    >
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item style={{ margin: "15px", paddingBottom: "10px" }}>
          <Typography variant="h3" gutterBottom display="inline">
            Edit Event Entry
          </Typography>
          <Typography>
            Choose who can enter the event and how attendees register.
          </Typography>
        </Grid>
      </Grid>
      <List>
        <ListItem>
          <Grid container spacing={6}>
            <Grid item md={12} className="checkboxPadding">
              <FormLabel id="demo-radio-buttons-group-label">
                Choose who can enter this event
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={tempEntrySettings.entryType}
                name="radio-buttons-group"
                onChange={(e) =>
                  setTempEntrySettings({
                    ...tempEntrySettings,
                    entryType: e.target.value,
                  })
                }
              >
                <FormControlLabel
                  value="anyone-link"
                  control={<Radio />}
                  label="Anyone can enter via their unique link (Recommended for public events)"
                />
                <FormControlLabel
                  value="invited-only"
                  control={<Radio />}
                  label="Only invited people can enter"
                />
                <FormControlLabel
                  value="anyone-signin"
                  control={<Radio />}
                  label="Anyone can enter after sign in"
                />
                <FormControlLabel
                  value="anyone-no-signin"
                  control={<Radio />}
                  label="Anyone can enter without sign in"
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </ListItem>
      </List>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => updateEventEntrySettings(tempEntrySettings.entryType)}
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Save"}
        </Button>
      </DialogActions>
    </Box>
  );

  return (
    <Grid justifyContent="space-between" container spacing={10}>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert
          onClose={() => setAlert({ ...alert, open: false })}
          severity={alert.severity}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <Grid item md={12}>
        <Typography variant="h3" gutterBottom display="inline">
          Event Entry
        </Typography>
        <Typography>
          Configure what information should be captured during registration
        </Typography>
        <br />
        <Typography variant="h5" gutterBottom display="inline">
          Who can enter this event when it's live?
        </Typography>
        <Typography>
          Choose who can enter the event and how they register.
        </Typography>
        <br />
        <Grid container>
          <Grid md={8}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ display: "flex", alignItems: "center" }}
            >
              <AddIcon style={{ marginRight: "8px" }} />
              {entryTypeLabels[entrySettings.entryType] ||
                "Anyone can enter via their unique link"}
            </Typography>
          </Grid>
          <Grid md={4}>
            <Link
              variant="contained"
              color="primary"
              onClick={toggleDrawer("right", true)}
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                paddingRight: "15px",
                fontSize: "0.9rem",
              }}
            >
              Edit
            </Link>
            <Drawer
              anchor={"right"}
              open={state["right"]}
              onClose={toggleDrawer("right", false)}
            >
              {list("right")}
            </Drawer>
            <Link
              variant="contained"
              color="primary"
              onClick={() => setOpen(true)}
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "0.9rem",
              }}
            >
              New Attendee
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Paper mt={4}>
        <div>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="form-dialog-title"
            maxWidth="md"
            fullWidth
          >
            <DialogTitle id="form-dialog-title">Add New Attendee</DialogTitle>
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                jobTitle: "",
                organization: "",
                city: "",
                country: "",
                addedVia: "Register",
                sendEmail: false,
              }}
              validationSchema={attendeeValidationSchema}
              onSubmit={handleCreateAttendee}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                      Add attendees to the attendee list. For a seamless
                      one-click registration/entry for your attendees, please
                      fill all mandatory form fields.
                    </DialogContentText>

                    <Grid container spacing={2}>
                      {/* Add Via */}
                      <Grid item xs={12}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Add Via</FormLabel>
                          <RadioGroup
                            row
                            aria-label="addedVia"
                            name="addedVia"
                            value={values.addedVia}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              value="Register"
                              control={<Radio />}
                              label="Register attendee"
                            />
                            <FormControlLabel
                              value="Invite"
                              control={<Radio />}
                              label="Invite Attendee"
                            />
                          </RadioGroup>
                          {touched.addedVia && errors.addedVia && (
                            <Typography color="error" variant="caption">
                              {errors.addedVia}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      {/* Name Fields */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          name="firstName"
                          label="First Name"
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.firstName && Boolean(errors.firstName)}
                          helperText={touched.firstName && errors.firstName}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          name="lastName"
                          label="Last Name"
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.lastName && Boolean(errors.lastName)}
                          helperText={touched.lastName && errors.lastName}
                          fullWidth
                        />
                      </Grid>

                      {/* Email */}
                      <Grid item xs={12}>
                        <TextField
                          name="email"
                          label="Email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.email && Boolean(errors.email)}
                          helperText={touched.email && errors.email}
                          fullWidth
                        />
                      </Grid>

                      {/* Job and Organization */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          name="jobTitle"
                          label="Job Title"
                          value={values.jobTitle}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.jobTitle && Boolean(errors.jobTitle)}
                          helperText={touched.jobTitle && errors.jobTitle}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          name="organization"
                          label="Organization"
                          value={values.organization}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.organization && Boolean(errors.organization)
                          }
                          helperText={
                            touched.organization && errors.organization
                          }
                          fullWidth
                        />
                      </Grid>

                      {/* City and Country */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          name="city"
                          label="City"
                          value={values.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.city && Boolean(errors.city)}
                          helperText={touched.city && errors.city}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControl
                          fullWidth
                          error={touched.country && Boolean(errors.country)}
                        >
                          <InputLabel id="country-label">Country</InputLabel>
                          <Select
                            labelId="country-label"
                            id="country"
                            name="country"
                            label="Country"
                            value={values.country}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            {countries.map((country) => (
                              <MenuItem key={country.code} value={country.name}>
                                {country.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.country && errors.country && (
                            <Typography color="error" variant="caption">
                              {errors.country}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      {/* Send Email Checkbox - Only show for Register attendee */}
                      {values.addedVia === "Register" && (
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="sendEmail"
                                checked={values.sendEmail}
                                onChange={handleChange}
                              />
                            }
                            label="Send invitation email with unique access link"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setOpen(false)} color="inherit">
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      disabled={isSubmitting || attendeeLoading}
                    >
                      {isSubmitting || attendeeLoading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Add Attendee"
                      )}
                    </Button>
                  </DialogActions>
                </form>
              )}
            </Formik>
          </Dialog>
        </div>
      </Paper>
    </Grid>
  );
}

function PreEventEntryTab({ eventId }) {
  const [earlyAccessState, setEarlyAccessState] = useState({
    right: false,
  });

  const [loading, setLoading] = useState(false);
  const [preEventSettings, setPreEventSettings] = useState({
    enabled: false,
    notifyRegistrants: false,
    features: {
      messages: false,
      meetings: false,
      booths: false,
      feed: false,
      lounge: false,
    },
  });

  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Fetch pre-event entry settings on component mount
  useEffect(() => {
    fetchPreEventSettings();
  }, [eventId]);

  const fetchPreEventSettings = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          query GetEvent($eventId: ID!) {
            getEvent(id: $eventId) {
              id
              name
              entrySettings {
                preEventEntry {
                  enabled
                  notifyRegistrants
                  features {
                    messages
                    meetings
                    booths
                    feed
                    lounge
                  }
                }
              }
            }
          }
        `,
        variables: {
          eventId,
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error fetching pre-event settings"
        );
      }

      const event = response.data.getEvent;

      if (event?.entrySettings?.preEventEntry) {
        const preEventEntry = event.entrySettings.preEventEntry;
        setPreEventSettings({
          enabled: preEventEntry.enabled || false,
          notifyRegistrants: preEventEntry.notifyRegistrants || false,
          features: {
            messages: preEventEntry.features?.messages || false,
            meetings: preEventEntry.features?.meetings || false,
            booths: preEventEntry.features?.booths || false,
            feed: preEventEntry.features?.feed || false,
            lounge: preEventEntry.features?.lounge || false,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching pre-event settings:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to load pre-event settings",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const updatePreEventSettings = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation UpdatePreEventEntrySettings($eventId: ID!, $input: PreEventEntrySettingsInput!) {
            updatePreEventEntrySettings(eventId: $eventId, input: $input) {
              id
              entrySettings {
                preEventEntry {
                  enabled
                  notifyRegistrants
                  features {
                    messages
                    meetings
                    booths
                    feed
                    lounge
                  }
                }
              }
            }
          }
        `,
        variables: {
          eventId,
          input: {
            enabled: true, // Enabling since we're updating from the Early Access drawer
            notifyRegistrants: preEventSettings.notifyRegistrants,
            features: preEventSettings.features,
          },
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error updating pre-event settings"
        );
      }

      // Update local state with new settings
      setPreEventSettings({
        ...preEventSettings,
        enabled: true,
      });

      setAlert({
        open: true,
        message: "Pre-event entry settings updated successfully",
        severity: "success",
      });

      // Close the drawer
      setEarlyAccessState({ ...earlyAccessState, right: false });
    } catch (error) {
      console.error("Error updating pre-event settings:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to update pre-event settings",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const disablePreEventEntry = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation UpdatePreEventEntrySettings($eventId: ID!, $input: PreEventEntrySettingsInput!) {
            updatePreEventEntrySettings(eventId: $eventId, input: $input) {
              id
              entrySettings {
                preEventEntry {
                  enabled
                }
              }
            }
          }
        `,
        variables: {
          eventId,
          input: {
            enabled: false, // Disabling pre-event entry
            notifyRegistrants: preEventSettings.notifyRegistrants,
            features: preEventSettings.features,
          },
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error disabling pre-event entry"
        );
      }

      // Update local state
      setPreEventSettings({
        ...preEventSettings,
        enabled: false,
      });

      setAlert({
        open: true,
        message: "Pre-event entry disabled successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error disabling pre-event entry:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to disable pre-event entry",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const enablePreEventEntry = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation UpdatePreEventEntrySettings($eventId: ID!, $input: PreEventEntrySettingsInput!) {
            updatePreEventEntrySettings(eventId: $eventId, input: $input) {
              id
              entrySettings {
                preEventEntry {
                  enabled
                }
              }
            }
          }
        `,
        variables: {
          eventId,
          input: {
            enabled: true, // Enabling pre-event entry
            notifyRegistrants: preEventSettings.notifyRegistrants,
            features: preEventSettings.features,
          },
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0].message || "Error enabling pre-event entry"
        );
      }

      // Update local state
      setPreEventSettings({
        ...preEventSettings,
        enabled: true,
      });

      setAlert({
        open: true,
        message: "Pre-event entry enabled successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error enabling pre-event entry:", error);
      setAlert({
        open: true,
        message: error.message || "Failed to enable pre-event entry",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle switch changes
  const handleSwitchChange = (feature) => (event) => {
    setPreEventSettings({
      ...preEventSettings,
      features: {
        ...preEventSettings.features,
        [feature]: event.target.checked,
      },
    });
  };

  // Handle notify registrants checkbox change
  const handleNotifyChange = (event) => {
    setPreEventSettings({
      ...preEventSettings,
      notifyRegistrants: event.target.checked,
    });
  };

  const toggleEarlyAccessDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setEarlyAccessState({ ...earlyAccessState, [anchor]: open });
  };

  const earlyAccessSettings = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      style={{ width: "550px" }}
    >
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item style={{ margin: "15px", paddingBottom: "10px" }}>
          <Typography variant="h3" gutterBottom display="inline">
            Enable Early Access
          </Typography>
          <Typography>
            Participants who have registered for the event can now enter before
            the event begins. You can enable your attendees to build their
            agenda and explore networking opportunities in advance.
          </Typography>
        </Grid>
      </Grid>
      <List>
        <ListItem>
          <Grid container spacing={6}>
            <Grid item md={12} className="checkboxPadding">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={preEventSettings.notifyRegistrants}
                      onChange={handleNotifyChange}
                    />
                  }
                  label="Send an email to the already registered participants to inform them about the early access"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </ListItem>
      </List>
      <List>
        <ListItem>
          <Grid container spacing={6}>
            <Grid item md={12} className="checkboxPadding">
              <FormLabel id="demo-radio-buttons-group-label">
                Enable/disable activities available in early access
              </FormLabel>
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
              >
                <Divider />
                <ListItem alignItems="flex-start">
                  <Grid container>
                    <Grid md={8}>
                      <ListItemText
                        primary="Messages"
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              Attendees will be able to send messages to other
                              participants
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid md={4}>
                      <Switch
                        checked={preEventSettings.features.messages}
                        onChange={handleSwitchChange("messages")}
                        inputProps={{ "aria-label": "messages switch" }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem alignItems="flex-start">
                  <Grid container>
                    <Grid md={8}>
                      <ListItemText
                        primary="Schedule meetings"
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              Attendees will be able to schedule meetings
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid md={4}>
                      <Switch
                        checked={preEventSettings.features.meetings}
                        onChange={handleSwitchChange("meetings")}
                        inputProps={{ "aria-label": "meetings switch" }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem alignItems="flex-start">
                  <Grid container>
                    <Grid md={8}>
                      <ListItemText
                        primary="Booths"
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              Attendees will be able to enter the booths and
                              connect with the exhibitors.
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid md={4}>
                      <Switch
                        checked={preEventSettings.features.booths}
                        onChange={handleSwitchChange("booths")}
                        inputProps={{ "aria-label": "booths switch" }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem alignItems="flex-start">
                  <Grid container>
                    <Grid md={8}>
                      <ListItemText
                        primary="Feed"
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              Attendees will receive feed
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid md={4}>
                      <Switch
                        checked={preEventSettings.features.feed}
                        onChange={handleSwitchChange("feed")}
                        inputProps={{ "aria-label": "feed switch" }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem alignItems="flex-start">
                  <Grid container>
                    <Grid md={8}>
                      <ListItemText
                        primary="Lounge"
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              Attendees will be able to enter the lounge and
                              join the tables to interact with others.
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid md={4}>
                      <Switch
                        checked={preEventSettings.features.lounge}
                        onChange={handleSwitchChange("lounge")}
                        inputProps={{ "aria-label": "lounge switch" }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
              </List>
            </Grid>
          </Grid>
        </ListItem>
      </List>
      <DialogActions>
        <Button
          onClick={toggleEarlyAccessDrawer("right", false)}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={updatePreEventSettings}
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Save"}
        </Button>
      </DialogActions>
    </Box>
  );

  return (
    <Grid item md={12}>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert
          onClose={() => setAlert({ ...alert, open: false })}
          severity={alert.severity}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <Typography variant="h3" gutterBottom display="inline">
        Pre & Post Event Entry
      </Typography>
      <br />
      <br />
      <Grid container>
        <Grid md={8}>
          <Typography variant="h5" gutterBottom display="inline">
            Pre-event Entry
          </Typography>
          <Typography>
            Allow people to enter the event before it opens so they can network
            and schedule meetings
          </Typography>
          {preEventSettings.enabled && (
            <Box
              mt={2}
              sx={{ p: 2, backgroundColor: "#f0f8ff", borderRadius: 1 }}
            >
              <Typography variant="subtitle2" color="primary">
                Early access is enabled
              </Typography>
              <Box mt={1}>
                {preEventSettings.features.messages && (
                  <Chip label="Messages" size="small" sx={{ mr: 1, mb: 1 }} />
                )}
                {preEventSettings.features.meetings && (
                  <Chip label="Meetings" size="small" sx={{ mr: 1, mb: 1 }} />
                )}
                {preEventSettings.features.booths && (
                  <Chip label="Booths" size="small" sx={{ mr: 1, mb: 1 }} />
                )}
                {preEventSettings.features.feed && (
                  <Chip label="Feed" size="small" sx={{ mr: 1, mb: 1 }} />
                )}
                {preEventSettings.features.lounge && (
                  <Chip label="Lounge" size="small" sx={{ mr: 1, mb: 1 }} />
                )}
              </Box>
            </Box>
          )}
        </Grid>
        <Grid md={4}>
          <Link
            variant="contained"
            color="primary"
            onClick={toggleEarlyAccessDrawer("right", true)}
            style={{
              textDecoration: "none",
              fontWeight: "bold",
              paddingRight: "15px",
              fontSize: "0.9rem",
            }}
          >
            Edit
          </Link>
          <Drawer
            anchor={"right"}
            open={earlyAccessState["right"]}
            onClose={toggleEarlyAccessDrawer("right", false)}
          >
            {earlyAccessSettings("right")}
          </Drawer>
          {preEventSettings.enabled && (
            <Link
              variant="contained"
              color="error"
              onClick={disablePreEventEntry}
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "0.9rem",
                color: "rgb(211, 47, 47)",
              }}
            >
              {loading ? "Disabling..." : "Disable"}
            </Link>
          )}
          {!preEventSettings.enabled && (
            <Link
              variant="contained"
              color="primary"
              onClick={enablePreEventEntry}
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "0.9rem",
                color: "rgb(25, 118, 210)",
              }}
            >
              {loading ? "Enabling..." : "Enable"}
            </Link>
          )}
        </Grid>
      </Grid>
      <br />
    </Grid>
  );
}

function EventEntry({ eventId }) {
  return (
    <React.Fragment>
      <EventEntryTab eventId={eventId} />
      <Divider my={6} />
      <PreEventEntryTab eventId={eventId} />
    </React.Fragment>
  );
}

export default EventEntry;
